const DEFAULT_MAX_BYTES = 1800 * 1024;
const DEFAULT_MAX_DIMENSION = 1600;

const loadImage = (file) => new Promise((resolve, reject) => {
  const image = new Image();
  const url = URL.createObjectURL(file);

  image.onload = () => {
    URL.revokeObjectURL(url);
    resolve(image);
  };
  image.onerror = () => {
    URL.revokeObjectURL(url);
    reject(new Error('Could not read image file.'));
  };
  image.src = url;
});

const canvasToBlob = (canvas, quality) => new Promise((resolve, reject) => {
  canvas.toBlob((blob) => {
    if (blob) {
      resolve(blob);
      return;
    }

    reject(new Error('Could not compress image.'));
  }, 'image/jpeg', quality);
});

export const compressImageForUpload = async (
  file,
  maxBytes = DEFAULT_MAX_BYTES,
  maxDimension = DEFAULT_MAX_DIMENSION,
  label = 'Photo de profil'
) => {
  if (file.size <= maxBytes && file.type === 'image/jpeg') {
    return file;
  }

  const image = await loadImage(file);
  const scale = Math.min(1, maxDimension / Math.max(image.width, image.height));
  const width = Math.max(1, Math.round(image.width * scale));
  const height = Math.max(1, Math.round(image.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0, width, height);

  let quality = 0.86;
  let blob = await canvasToBlob(canvas, quality);

  while (blob.size > maxBytes && quality > 0.45) {
    quality -= 0.08;
    blob = await canvasToBlob(canvas, quality);
  }

  if (blob.size > maxBytes) {
    throw new Error(`${label} est trop volumineuse. Veuillez choisir une image plus petite.`);
  }

  const filename = file.name.replace(/\.[^.]+$/, '') || 'profile-photo';
  return new File([blob], `${filename}.jpg`, { type: 'image/jpeg' });
};
